<template>
  <section>
    <hotel-list :query="query" />
  </section>
</template>

<script>
import HotelList from '@/components/basic/HotelList'

export default {
  name: 'Hotels',
  components: {
    HotelList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
